import React, { useState } from "react";
import { Button, Container, Dropdown, DropdownButton } from "react-bootstrap";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa";
import "./First.css";
import { useNavigate } from "react-router-dom";
const First = () => {
  const [activeItem, setActiveItem] = useState(0);

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/ContactUs");
  };

  const handleItemClick = (index) => {
    setActiveItem(index);
  };
  return (
    <>
      <section className="career-section">
        <Container>
          <div className="main-title">
            <h1 className="text-capitalize">careers</h1>
          </div>
          <div className="search-location-form">
            <div className="form-group select-location-input">
              <div className="custom-html-dropdown">
                <DropdownButton id="dropdown-basic-button" title="Location">
                  <Dropdown.Item>All Locations</Dropdown.Item>
                  <Dropdown.Item>Mota Varchha (Surat)</Dropdown.Item>
                </DropdownButton>
              </div>
            </div>
            <div className="form-search-block">
              <div className="row">
                <div className="col-sm-8">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Keywords (ex php developer)"
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <Button className="btn btn-primary">Show All Jobs</Button>
                </div>
              </div>
            </div>
          </div>
          <div className="careers-skills-block">
            <div className="careers-items-list">
              {[
                "MERN Stack Developer",
                "Shopify Developer",
                "Wordpress Developer",
                "Jr. QA",
                "Senior BDE",
                "Hardware and Network Engineer",
              ].map((title, index) => (
                <span
                  key={index}
                  className={`careers-item ${
                    activeItem === index ? "active" : ""
                  }`}
                  onClick={() => handleItemClick(index)}
                >
                  <h2 className="position-title">{title}</h2>
                  <div className="experience-name">
                    {index === 0 && "Exp. 2+ years"}
                    {index === 1 && "Exp. 3+ years"}
                    {index === 2 && "Exp. 2+ years"}
                    {index === 3 && "Exp. 1+ years"}
                    {index === 4 && "Exp. 3-4 Years"}
                    {index === 5 && "Exp. 1+ years"}
                  </div>
                </span>
              ))}
            </div>
            <div className="careers-content-block">
              <div
                className={`careers-item ${activeItem === 0 ? "active" : ""}`}
              >
                <h2 className="position-title">MERN Stack Developer</h2>
                <div className="experience-name mb-5">Exp. 2+ years</div>
                <ul className="skills-tags-wrap mb-5">
                  <li className="tag-name">Backend</li>
                  <li className="tag-name">Database Design</li>
                  <li className="tag-name">Express.JS</li>
                  <li className="tag-name">Frontend</li>
                  <li className="tag-name">Full Stack Development</li>
                  <li className="tag-name">Javascript</li>
                  <li className="tag-name">MERN Stack</li>
                  <li className="tag-name">MongoDB</li>
                  <li className="tag-name">Node JS</li>
                  <li className="tag-name">React</li>
                  <li className="tag-name">RESTful API</li>
                  <li className="tag-name">Web development</li>
                </ul>
                <div className="apply-action-btns mb-5">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="info-content entry-content mb-5">
                  <div className="ltr">
                    We are in search of a skilled and innovative MERN (MongoDB,
                    Express.js, React, Node.js) stack developer to join our
                    dynamic team. The ideal candidate will demonstrate
                    proficiency in the MERN stack, showcasing a strong portfolio
                    of successful projects. As a MERN stack developer, you will
                    play a crucial role in designing, building, and maintaining
                    scalable web applications.
                  </div>
                  <p>Position: MERN Stack Developer</p>
                  <p>
                    Number of Vacancies: 1<br />
                    Location: Adajan (Surat) and Bhatar (Surat)
                    <br />
                    Qualification: Proven work experience as a MERN Stack
                    developer
                  </p>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Qualifications</h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Bachelor’s degree in Computer Science, Engineering, or a
                        related field.
                      </li>
                      <li>
                        Proven experience of at least 2 years in MERN stack
                        development.
                      </li>
                      <li>
                        A strong portfolio showcasing successful MERN stack
                        projects.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Key Responsibilities </h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Develop and maintain web applications using the MERN
                        stack, ensuring high performance and responsiveness.
                      </li>
                      <li>
                        Collaborate with cross-functional teams to design,
                        architect, and implement robust solutions.
                      </li>
                      <li>
                        Create and maintain RESTful APIs for seamless
                        communication between the front end and back end.
                      </li>
                      <li>
                        Implement effective and secure data storage solutions
                        using MongoDB and other databases.
                      </li>
                      <li>
                        Optimize applications for maximum speed, scalability,
                        and scalability & security.
                      </li>
                      <li>
                        Participate in code reviews to maintain code quality and
                        enhance team collaboration.
                      </li>
                      <li>
                        Stay updated with industry trends and technologies,
                        incorporating best practices into development processes.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Required Skill </h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Proven experience as a MERN stack developer or similar
                        role.
                      </li>
                      <li>
                        Proficiency in MongoDB, Express.js, React, and Node.js.
                      </li>
                      <li>
                        Strong understanding of Typescript, JavaScript,
                        including ES6+ syntax.
                      </li>
                      <li>
                        Experience with front-end technologies such as HTML,
                        CSS, and client-side scripting libraries.
                      </li>
                      <li>
                        Familiarity with state management libraries such as
                        Redux.
                      </li>
                      <li>Knowledge of RESTful API design and development.</li>
                      <li>
                        Understanding of database design and management using
                        MongoDB.
                      </li>
                      <li>
                        Excellent problem-solving skills and attention to
                        detail.
                      </li>
                      <li>
                        Effective communication skills for seamless
                        collaboration with team members.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Nice to Have</h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Experience with InfluxDB, Redis, GraphQL, Neo4J, MySQL,
                        etc.
                      </li>
                      <li>
                        Knowledge of containerization and orchestration tools
                        like Docker and Kubernetes.
                      </li>
                      <li>
                        Familiarity with continuous integration and deployment
                        processes.
                      </li>
                      <li>Understanding of serverless architecture.</li>
                      <li>
                        Exposure to cloud platforms such as AWS, Azure, or
                        Google Cloud.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="apply-action-btns">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={`careers-item ${activeItem === 1 ? "active" : ""}`}
              >
                <h2 className="position-title">Shopify Developer</h2>
                <div className="experience-name mb-5">Exp. 3+ years</div>
                <ul className="skills-tags-wrap mb-5">
                  <li className="tag-name">API Integrations</li>
                  <li className="tag-name">Custom Scripts</li>
                  <li className="tag-name">Custom Shopify Template</li>
                  <li className="tag-name">Liquid</li>
                  <li className="tag-name">Shopify Customization</li>
                  <li className="tag-name">Shopify Inventory Modules</li>
                  <li className="tag-name">Shopify Plus</li>
                  <li className="tag-name">Shopify Polaris</li>
                  <li className="tag-name">Theme/App Development</li>
                </ul>
                <div className="apply-action-btns mb-5">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="info-content entry-content mb-5">
                  <div className="ltr">
                    We are looking to hire a skilled Shopify developer to design
                    and implement attractive and functional e-commerce websites
                    for our clients, with a strong focus on customization. You
                    will be responsible for both back-end and front-end
                    development, including the implementation of custom Shopify
                    themes and apps development, as well as site integration and
                    security updates.
                  </div>
                  <p>Position: Shopify Developer</p>
                  <p>
                    Number of Vacancies: 1<br />
                    Experience: 3+ years
                    <br />
                    Location: Adajan (Surat) and Bhatar (Surat)
                    <br />
                    Qualification: Proven work experience as a Shopify
                    developer.
                  </p>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Qualifications</h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>Proven work experience as a Shopify developer.</li>
                      <li>
                        Strong knowledge of Shopify’s templating language
                        (Liquid).
                      </li>
                      <li>Optimizing page speed of Shopify sites.</li>
                      <li>
                        Knowledge of front-end technologies including CSS3,
                        JavaScript, HTML5, and jQuery.
                      </li>
                      <li>
                        Experience building user interfaces for websites and/or
                        web applications.
                      </li>
                      <li>
                        Experience designing and developing responsive design
                        websites.
                      </li>
                      <li>
                        Ability to convert comprehensive layout and wireframes
                        into working HTML5/CSS3 templates.
                      </li>
                      <li>
                        Knowledge of code versioning tools including Git and
                        SVN.
                      </li>
                      <li>
                        Experience working with debugging tools such as Chrome
                        Inspector and Firebug.
                      </li>
                      <li>
                        Good understanding of website architecture and
                        aesthetics.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Key Responsibilities </h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Designing, developing, and customizing front-end and
                        architecture for Shopify websites.
                      </li>
                      <li>
                        Implementing and optimizing Shopify themes, apps, and
                        third-party integrations.
                      </li>
                      <li>
                        Executing custom Shopify development projects, including
                        API integrations, advanced inventory modules, and
                        template customization.
                      </li>
                      <li>
                        Managing back-end processes including database
                        integration and server management for scalable
                        solutions.
                      </li>
                      <li>
                        Ensuring websites adhere to high performance, security,
                        and compliance standards.
                      </li>
                      <li>
                        Analyzing website performance metrics and
                        troubleshooting technical issues.
                      </li>
                      <li>
                        Maintaining clean, reusable code and comprehensive
                        documentation.
                      </li>
                      <li>
                        Collaborating with design and marketing teams to ensure
                        seamless website functionality and user experience.
                      </li>
                      <li>
                        Keeping abreast of industry trends and advancements in
                        e-commerce technologies.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Required Skill </h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>HTML5, CSS3, JavaScript, and Liquid.</li>
                      <li>
                        Strong understanding of industry trends and e-commerce
                        platforms.
                      </li>
                      <li>
                        Experience with responsive and adaptive design is
                        strongly preferred.
                      </li>
                      <li>
                        An understanding of the entire web development process,
                        including design, development, and deployment, is
                        preferred.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Nice to Have</h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Knowledge of cloud concepts and deployment strategies.
                      </li>
                      <li>
                        Experience with Shopify Plus and enterprise-level
                        projects.
                      </li>
                      <li>
                        Familiarity with RESTful APIs and web services
                        integration.
                      </li>
                      <li>
                        Understanding of SEO principles and techniques for
                        e-commerce websites.
                      </li>
                      <li>
                        Proficiency in additional front-end frameworks or
                        back-end languages.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="apply-action-btns">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={`careers-item ${activeItem === 2 ? "active" : ""}`}
              >
                <h2 className="position-title">WordPress Developer</h2>
                <div className="experience-name mb-5">Exp. 2+ years</div>
                <ul className="skills-tags-wrap mb-5">
                  <li className="tag-name">ACF</li>
                  <li className="tag-name">Page Builders</li>
                  <li className="tag-name">Payment Gateways</li>
                  <li className="tag-name">SEO</li>
                  <li className="tag-name">Wordpress</li>
                </ul>
                <div className="apply-action-btns mb-5">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="info-content entry-content mb-5">
                  <div className="ltr">
                    We are looking to hire a skilled WordPress developer to
                    design and implement attractive and functional websites for
                    our clients.You will be responsible for both back-end and
                    front-end development including the implementation of
                    WordPress themes and plugins as well as site integration and
                    security updates.This position requires a combination of
                    programming skills (namely PHP, HTML5, CSS3, and
                    JavaScript).The candidate should have a strong understanding
                    of industry trends and content management systems.Experience
                    with responsive and adaptive design is strongly preferred.
                    Also, an understanding of the entire web development
                    process,including design, development, and deployment is
                    preferred.
                  </div>
                  <p>Position: WordPress Developer</p>
                  <p>
                    Number of Vacancies: 1<br />
                    Experience: Min 1 years
                    <br />
                    Location: Adajan (Surat) and Bhatar (Surat)
                    <br />
                    Qualification: Proven work experience as a WordPress
                    developer.
                  </p>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Key Responsibilities </h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>Designing and building the website front-end.</li>
                      <li>Creating the website architecture.</li>
                      <li>
                        Expertise in WordPress Custom Theme Development and
                        Plugin Development.
                      </li>
                      <li>
                        Designing and managing the website back-end including
                        database and server integration.
                      </li>
                      <li>
                        Analyzing website performance and troubleshooting
                        errors.
                      </li>
                      <li>
                        Ensuring high-performance and availability and managing
                        all technical aspects of the CMS.
                      </li>
                      <li>Testing and troubleshooting the website.</li>
                      <li>Maintain well-documented and reusable code.</li>
                      <li>Maintaining website security and compliance.</li>
                      <li>Ensuring the overall quality of a project.</li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Qualifications</h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>Proven work experience as a WordPress developer.</li>
                      <li>
                        Strong knowledge of page builders like Elementor,DIVI,
                        Beaver, Visual Composer etc.
                      </li>
                      <li>Optimizing page speed of WordPress sites.</li>
                      <li>
                        Knowledge of front-end technologies including CSS3,
                        JavaScript, HTML5, and jQuery.
                      </li>
                      <li>
                        Experience building user interfaces for websites and/or
                        web applications.
                      </li>
                      <li>
                        Experience designing and developing responsive design
                        websites.
                      </li>
                      <li>
                        Ability to convert comprehensive layout and wireframes
                        into working HTML5/CSS3 templates.
                      </li>
                      <li>
                        Knowledge of code versioning tools including Git and
                        SVN.
                      </li>
                      <li>
                        Experience working with debugging tools such as Chrome
                        Inspector and Firebug.
                      </li>
                      <li>
                        Good understanding of website architecture and
                        aesthetics.
                      </li>
                      <li>
                        Experience working with debugging tools such as Chrome
                        Inspector and Firebug.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Nice to have </h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>GitHub/Bitbucket knowledge.</li>
                      <li>Experience with html/css would be an advantage.</li>
                      <li>
                        Knowledge of how to interact with RESTful APIs and
                        formats (JSON, XML).
                      </li>
                      <li>Cloud concepts knowledge.</li>
                    </ul>
                  </div>
                </div>
                <div className="apply-action-btns">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={`careers-item ${activeItem === 3 ? "active" : ""}`}
              >
                <h2 className="position-title">Jr. QA</h2>
                <div className="experience-name mb-5">Exp. 1+ years</div>
                <ul className="skills-tags-wrap mb-5">
                  <li className="tag-name">Bug</li>
                  <li className="tag-name">Manual Tester</li>
                  <li className="tag-name">Quality Assurance</li>
                  <li className="tag-name">Test Management</li>
                  <li className="tag-name">Test Summary</li>
                </ul>
                <div className="apply-action-btns mb-5">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="info-content entry-content mb-5">
                  <div className="ltr">
                    We are seeking a QA Tester whose primary responsibility is
                    to test entire applications and software products to
                    identify issues, should report all the bugs, and execute
                    test cases efficiently. Your ultimate goal will be to make
                    sure that all our systems and apps work smoothly without any
                    glitches.
                  </div>
                  <p>Position: Jr. QA</p>
                  <p>
                    Number of Vacancies: 1<br />
                    Experience: 1+ years
                    <br />
                    Location: Adajan (Surat) and Bhatar (Surat)
                    <br />
                    Qualification: B.E/B.Tech in Computer Science or any
                    relevant field
                  </p>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Role and Responsibility</h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Participate in user story analysis and in defining
                        acceptance criteria, including non-functional
                        requirements.
                      </li>
                      <li>Prepare and execute test plans.</li>
                      <li>
                        Participate as a member in fully agile scrum deliveries.
                      </li>
                      <li>
                        Use testing tools for defect tracking and issue
                        resolution.
                      </li>
                      <li>
                        Investigate and recommend process improvements and be an
                        active participant in regular retrospective meetings.
                      </li>
                      <li>
                        Troubleshoot issues in various testing environments.
                      </li>
                      <li>
                        Document test efforts and results, and communicate them
                        with the project manager, developers, and QA team as
                        required.
                      </li>
                      <li>
                        Ensure all tasks worked on during the day are updated on
                        a daily basis to the DevOps team.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Required Skills</h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Experience in creating test conditions, test data, and
                        test cases.
                      </li>
                      <li>
                        Strong understanding of testing challenges for various
                        types of tests, including new features, regression,
                        smoke, load, and performance testing.
                      </li>
                      <li>
                        Experience working in an agile development environment,
                        ideally with experience working with a distributed team.
                      </li>
                      <li>Strong analytical and investigative skills.</li>
                      <li>Strong verbal and written communication.</li>
                      <li>
                        Experience in working with Jira, Git, Bitbucket, and
                        SVN.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Nice to Have</h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Good grasp of API Testing using Postman and SOAP UI.
                      </li>
                      <li>Experience in DB testing.</li>
                      <li>
                        Good to have performance testing experience using tools
                        like Jmeter.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="apply-action-btns">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={`careers-item ${activeItem === 4 ? "active" : ""}`}
              >
                <h2 className="position-title">Senior BDE</h2>
                <div className="experience-name mb-5">Exp. 3-4 Years</div>
                <ul className="skills-tags-wrap mb-5">
                  <li className="tag-name">BDE</li>
                  <li className="tag-name">BDM</li>
                  <li className="tag-name">Cold Calling</li>
                  <li className="tag-name">Email Marketing</li>
                  <li className="tag-name">LinkedIn</li>
                  <li className="tag-name">Sales</li>
                </ul>
                <div className="apply-action-btns mb-5">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="info-content entry-content mb-5">
                  <div className="ltr">
                    We are currently seeking a dynamic and results-driven
                    Business Development Executive to join our team. The ideal
                    candidate will have a minimum of 3-4 years of experience in
                    business development, with a proven track record of driving
                    revenue growth and building lasting client relationships.
                  </div>
                  <p>Position: Senior BDE</p>
                  <p>
                    Number of Vacancies: 1<br />
                    Experience: 3-4 years
                    <br />
                    Location: Adajan (Surat) and Bhatar (Surat)
                    <br />
                    Qualification: Bachelor’s degree in Business Administration,
                    Marketing, or a related field.
                  </p>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Role and Responsibilities:</h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Identify and pursue new business opportunities through
                        targeted prospecting and networking activities.
                      </li>
                      <li>
                        Build and maintain strong relationships with existing
                        clients to maximize customer satisfaction and retention.
                      </li>
                      <li>
                        Collaborate with the sales and marketing teams to
                        develop and implement effective sales strategies and
                        campaigns.
                      </li>
                      <li>Conduct outbound outreach activities.</li>
                      <li>
                        Negotiate contracts and agreements with clients to
                        ensure mutually beneficial partnerships.
                      </li>
                      <li>
                        Stay informed about industry trends and competitive
                        developments to identify potential opportunities for
                        business growth.
                      </li>
                      <li>
                        Engage in continuous training and professional
                        development
                      </li>
                      <li>
                        Collaborate on sales materials with the marketing team
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="apply-action-btns">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={`careers-item ${activeItem === 5 ? "active" : ""}`}
              >
                <h2 className="position-title">
                  Hardware and Network Engineer
                </h2>
                <div className="experience-name mb-5">Exp. 1+ years</div>
                <ul className="skills-tags-wrap mb-5">
                  <li className="tag-name">Hardware Engineer</li>
                  <li className="tag-name">Hardware Troubleshooting</li>
                  <li className="tag-name">Network Engineer</li>
                  <li className="tag-name">Operating System</li>
                  <li className="tag-name">Windows Linux</li>
                </ul>
                <div className="apply-action-btns mb-5">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="info-content entry-content mb-5">
                  <div className="ltr">
                    Seeking a skilled Hardware and Network Engineer with a
                    minimum of 1 year of experience. Responsible for
                    maintaining, troubleshooting, and upgrading hardware and
                    network systems to ensure optimal performance.
                  </div>
                  <p>Position: Hardware and Network Engineer</p>
                  <p>
                    Number of Vacancies: 1<br />
                    Experience: 1+ years
                    <br />
                    Location: Adajan (Surat) and Bhatar (Surat)
                    <br />
                    Qualification: Bachelor’s degree in Computer Science, IT, or
                    related field (or equivalent experience).
                  </p>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Key Responsibilities</h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Hardware Management:
                        <br />
                        Install, configure, and maintain computer hardware,
                        peripherals, and components.
                        <br />
                        Diagnose and repair hardware issues; perform upgrades
                        and replacements.
                      </li>
                      <li>
                        Technical Support:
                        <br />
                        Provide technical support to end-users, resolving
                        hardware and network-related issues.
                      </li>
                      <li>
                        System Maintenance:
                        <br />
                        Perform regular system backups and maintain data
                        integrity.
                        <br />
                        Keep system firmware and software patches up-to-date.
                      </li>
                      <li>
                        Project Involvement:
                        <br />
                        Participate in IT projects including network upgrades
                        and hardware implementation.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Required Skill </h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Technical: Basic hardware troubleshooting Network setup
                        (LAN/WAN) TCP/IP knowledge Router/switch configuration
                      </li>
                      <li>
                        Software: Windows/Linux OS Basic network security
                        Virtualization (VMware/Hyper-V)
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-info-content mb-5">
                  <h3>Nice to Have</h3>
                  <div className="card-info-content-info">
                    <ul>
                      <li>
                        Certifications: CompTIA A+, Network+, CCNA, or
                        equivalent.
                      </li>
                      <li>
                        Experience with virtualization technologies (VMware,
                        Hyper-V).
                      </li>
                      <li>
                        Familiarity with Windows and Linux operating systems.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="apply-action-btns">
                  <span className="btn btn-primary" onClick={handleClick}>
                    Apply Now
                  </span>
                  <div className="share-social-icons">
                    <span>Share</span>
                    <ul className="social-media-icons">
                      <li>
                        <span>
                          <FaLinkedinIn />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaFacebookF />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaTwitter />
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaWhatsapp />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
